<template>
  <div id="container" ref="mapRef" class="mainBox"></div>
  <!-- 使用 vue-baidu-map-3x 提供的 BaiduMap 组件 -->
  <div class="navBox"><Nav   @circle="clickNav"/></div>
  <div class="left flexColumn">
    <div class="leftBox1 flexColumn">
      <div class="title"><img src="../assets/img/huanjing/btzs.png" /> 空气监测数据</div>
      <div class="leftInfo1">
        <div  v-if="state.leftData1.length==0" class="kong"><img src="../assets/img/gbzntyj/qixiang/jiazi.gif" style="width:50px" />加载中</div>
        <div class="leftItem1" v-for="(item,index) in state.leftData1" v-else>
          <span class="time">{{item.created_at}}</span>
          <span class="wd">温度：{{item.soil_temperature}}℃</span>
          <span class="sd">湿度：{{item.soil_moisture}}%</span>
        </div>
      </div>
    </div>
    <div class="leftBox3">
      <div class="title"><img src="../assets/img/huanjing/btzs.png" />土壤监测数据</div>
      <div  v-if="state.leftData2.length==0" class="kong"><img src="../assets/img/gbzntyj/qixiang/jiazi.gif" style="width:50px" />加载中</div>
      <div class="leftItem3" v-for="(item,index) in state.leftData2">
        <div class="iconBox"></div>
        <div class="itemRight">
          <span>{{item.value}}</span>
          <span>{{item.name}}<i>({{item.unit}})</i></span>
        </div>
      </div>
    </div>
    <div class="leftBox2 flexColumn">
      <div class="title1">土壤温湿度</div>
      <div class="echarts">
        <div  v-if="state.leftData3.time==0" class="kong"><img src="../assets/img/gbzntyj/qixiang/jiazi.gif" style="width:50px" />加载中</div>
        <LeftLine :listData="state.leftData3" v-else />
      </div>
    </div>

  </div>
  <div class="right flexColumn">
    <div class="rightBox1 flexColumn">
      <div class="title"><img src="../assets/img/huanjing/btzs.png" />环境监测数据</div>
      <div  v-if="state.rightData1[0].value ==null" class="kong"><img src="../assets/img/gbzntyj/qixiang/jiazi.gif" style="width:50px" />加载中</div>
      <div class="rightInfo1" v-else>
        <div class="rightItem1" v-for="(item,index) in state.rightData1" :key="index">
          <div class="valueBg">{{item.value}}{{item.unit}}</div>
          <div class="name">{{item.name}}</div>
        </div>
      </div>
    </div>
    <div class="rightBox2 flexColumn">
      <div class="title"><img src="../assets/img/huanjing/btzs.png" />智能灌溉监测数据</div>
      <div class="leftBox1Content">
        <div class="leftBox1ContentTop">
          <div class="circle"></div>
          <img src="../assets/img/gbzntyj/gaungai/gg.png" class="circleImg" />
          <div class="leftBox1ContentTopList" v-if="state.showDiv">
            <div v-for="(item,index) in state.leftData1A" :key="index" class="leftBox1ContentTopItem  animate__animated" :class="index==0||index==2 ? 'animate__fadeInLeft' : 'animate__fadeInRight'">
              <div class="contentLine contentLine1"></div>
              <div class="contentLine contentLine2"></div>
              <div class="contentLine contentLine3"></div>
              <div class="contentLine contentLine4"></div>
              <span class="txt1">{{item.name}}</span><span class="txt2">{{item.value}}{{item.unit}}</span>
            </div>
          </div>
        </div>
        <div class="leftBox1ContentCenter">
          <div class="dateItem" :class="{dateItemCur:state.left1Cur==index}" v-for="(item,index) in state.leftData1Date" :key="index" @click="tabDate(dateItemCur)">{{item}}</div>
        </div>
        <div class="leftBox1ContentBottom">
          <div class="leftBox1ContentBottom1 animate__animated animate__fadeInLeft"  v-if="state.showDiv">
            <div class="leftBox1ContentBottomItem" v-for="(item,index) in state.leftData1B" :key="index">
              <div class="leftItem"><img :src="item.icon" /></div>
              <div class="rightCon"><span class="txt1">{{item.value}}</span><span class="txt2">{{item.name}}</span></div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
  <div class="center"></div>
  <CircleNav :isShow="state.circleShow"  @closeCircle1="circleHiddlen"  />
</template>

<script setup>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance,
  defineEmits
} from "vue";

// todo 项目使用请放开 leaflet 引入
import L from "leaflet";
import "leaflet/dist/leaflet.css";
// import * as L from 'leaflet/dist/leaflet.esm.js';
import Gep from "../utils/map.json";
import ldt from "../components/gbzntyj/ldt.vue";
import dczz from "../components/gbzntyj/dczz.vue";
// import leftPie from "../components/gbzntyj/leftBar.vue";
import footer1 from "@/components/footer.vue";
import Nav from "@/components/nav.vue";
import LeftLine from "../components/dataJc/leftLine";
import CircleNav from "@/components/circleNav.vue";
import utils from "@/utils/common";


    // const timer = ref(null);
    const router = useRouter();
    const mapRef = ref(null);
    const state = reactive({
      url: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img",
      AccessToken: "",
      imgShow:false,
      leftData1:[],
      leftData2:[],
      leftData3:{time:[],list:[]},

      rightData1:[
        {name:"空气温度",value:null,unit:"℃"},
        {name:"空气湿度",value:null,unit:"%"},
        {name:"土壤温度",value:null,unit:"℃"},
        {name:"土壤湿度",value:null,unit:"%"},
        {name:"风速",value:null,unit:"m/s"},
        {name:"光照强度",value:null,unit:"Lux"},
      ],

      leftData1A:[{name:"总流量",value:"0.01",unit:"m³/h"},{name:"运行速度",value:"45.0",unit:"m/h"},{name:"水渠液位",value:"0.3",unit:"m"},{name:"运行时间",value:"0.3",unit:"h"}],
      // leftData1Date:["4.05","4.12","4.16","4.20","4.26","4.30","5.02",],
      leftData1Date:[],
      left1Cur:0,
      leftData1B:[{name:"灌溉水量",value:"0.00",unit:"m³",icon:require('@/assets/img/gbzntyj/gaungai/sl.png')},{name:"灌溉亩数",value:"0.00",unit:"亩",icon:require('@/assets/img/gbzntyj/gaungai/ms.png')},{name:"亩均灌溉量",value:"0.00",unit:"m³/亩",icon:require('@/assets/img/gbzntyj/gaungai/pj.png')}],
      showDiv:true,
      circleShow:false

    });

    const emit = defineEmits(["mapLoad"]);
    const boundaryData = Gep;

    const marker = ref();
    const map = ref(null);
    let current = ref(0);

    // 地图底图
    // 第一种
    let mapType = ref("vec");
    let mapLabelType = ref("cva");

    // let mapType1 = ref(
    //   L.tileLayer(
    //     "https://gac-geo.googlecnapps.cn/maps/vt?lyrs=s&x={x}&y={y}&z={z}",
    //     {
    //       subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
    //     }
    //   )
    // );

    // let mapType1 = ref(
    //   L.tileLayer(
    //     "http://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=2543bd43d4f3f8b748d7ee2ecb82f74a",
    //     {
    //       subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
    //     }
    //   )
    // );
    let mapType1 = ref(
      L.tileLayer(
        "https://map1.aikenong.com.cn/maps/vt/lyrs=y&hl=zh-CN&gl=cn&scale=2&src=app&x={x}&y={y}&z={z}",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
        }
      )
    );
    let mapLabelType1 = ref(
      L.tileLayer(
        "https://t0.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=cia&STYLE=default&FORMAT=tiles&TILEMATRIXSET=w&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=2543bd43d4f3f8b748d7ee2ecb82f74a",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
        }
      )
    );
    // let mapLabelType1 = ref(
    //   L.tileLayer(
    //     "https://t{s}.tianditu.gov.cn/" +
    //       "cva" +
    //       "_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=" +
    //       "cva" +
    //       "&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILECOL={x}&TILEROW={y}&TILEMATRIX={z}&tk=2543bd43d4f3f8b748d7ee2ecb82f74a",
    //     {
    //       subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
    //     }
    //   )
    // );

    const initMap = () => {
      map.value.addLayer(mapType1.value);
      map.value.addLayer(mapLabelType1.value);
      map.value.on("click", ({ latlng }) => {
        console.log("坐标：", Object.values(latlng));
      });

      return map.value;
    };

    const mapObj = ref();


import {getRandomDate, setRandomDate, timeStr} from '../utils/getRandomDate';
    function getRadomDate(){

    }
    // 在 onMounted 中初始化地图
      const clearLocalStorage = () => {
        localStorage.removeItem('recentDate');
        console.log("清除")
      };
    //   let intervalId = null;
    onMounted(() => {
      clearLocalStorage()
      state.leftData1Date = setRandomDate(5,1)
      // console.log(Array.isArray(state.leftData1),state.leftData1)
      // let recentDate = localStorage.getItem("recentDate");
      // if(recentDate){
      //   const recentDate1 = recentDate.split(',');
      //   state.leftData1Date = recentDate1
      // }else{
      //   const daysAgo = ref(5);
      //   const recentDate = getRandomDate(daysAgo.value);
      //   localStorage.setItem('recentDate', recentDate);
      //   intervalId = setInterval(clearLocalStorage, 3 * 24 * 60 * 60 * 1000);
      //   state.leftData1Date = recentDate
      //   // console.log(recentDate)
      // }
      // console.log(state.leftData1Date)



      getData()
      // 获取视频AccessToken
      state.AccessToken = localStorage.getItem("AccessToken");
      // console.log(state.AccessToken);
      const text = "为深入贯彻落实党的二十大精神，按照新形势下国家粮食安全和农业可持续发展的总体要求，深入贯彻落实“藏粮于地、藏粮于技”战略，以推进农业现代化为目标，以促进农业可持续发展为主线，加强高标准农田建设，支持生态综合治理，提高农田抗御旱涝灾害的能力，加强农业基础设施建设，改善农业生产条件，提高农业特别是粮食综合生产能力。上蔡县委、县政府根据全县经济社会发展需求和自身条件，特别是县域耕地数量、质量和农业发展现状，经过多次规划选址、研讨论证，最终选定位于县城西南部的无量寺、大路李、黄埠3个乡镇的14个行政村和1个农场、1个种子站，集中连片5万亩耕地，作为县农业现代化高标准农田示范区。其中，以吴宋湖农场周边区域1.5万亩作为核心区先行打造。";
      state.textList = chunkString(text, 44);
      


      map.value = L.map(mapRef.value, {
        center: [33.248258780732435, 114.18800353654662],

        // center: [114.182633, 33.240019],
        zoom: 14,
        minZoom: 3,
        maxZoom: 19,
        noWrap: true,
        // dragging: false,
        zoomControl: true,
        attributionControl: false,
      });
      mapObj.value = initMap();
      // createMarkers();
      loadBoundary();
      for (const markerDatum of markersData) {
        for (const latlng of markerDatum.locations) {
          const iconPath = require(`../assets/img/icon/${markerDatum.iconName}`);

          const marker = createAndAddMarker(latlng, {
            title: `地标`,
            icon: L.icon({
              iconUrl: iconPath,
              iconSize: [34, 48], // 图标大小
              iconAnchor: [10, 10], // 图标锚点
              popupAnchor: [-3, -76], // 弹出窗锚点
            }),
          });

          // 假设没有针对每个点定制的弹出内容，可以根据需求添加
          // const popupContent = `<div style='width: 200px; height: 100px;font-size: 20px; color: aqua;'>${
          //   markerDatum.title ? markerDatum.title : "地标"
          // }</div>`;
          // marker.bindPopup(popupContent);
        }
      }
    });
    // 新增一个清除所有标记的方法
    function clearMarkers() {
      // 如果map.value存在并且有layers，则遍历删除所有标记
      if (map.value && map.value.eachLayer) {
        map.value.eachLayer((layer) => {
          if (layer instanceof L.Marker) {
            map.value.removeLayer(layer);
          }
        });
      }
    }
    // 假设有个按钮点击事件，用buttonClick表示
    function buttonClick(index) {
      // 清除所有已存在的标记
      clearMarkers();

      // 筛选出iconName为"1.png"的标记数据
      const filteredMarkers = markersData.find(
        (markerDatum) => markerDatum.iconName === index + ".png"
      );

      // 遍历筛选出来的标记数据，添加到地图上
      if (filteredMarkers) {
        for (const latlng of filteredMarkers.locations) {
          const iconPath = require(`../assets/img/icon/${filteredMarkers.iconName}`);

          const marker = createAndAddMarker(latlng, {
            title: `地标`,
            icon: L.icon({
              iconUrl: iconPath,
              iconSize: [34, 48],
              iconAnchor: [22, 94],
              popupAnchor: [-3, -76],
            }),
          });

          // 添加自定义的弹出内容
          // const popupContent = `<div style='width: 200px; height: 100px;font-size: 20px; color: aqua;border: 1px solid #19e1cb;'>${
          //   filteredMarkers.title ? filteredMarkers.title : "地标"
          // }</div>`;
          // marker.bindPopup(popupContent);
        }
      }
    }

    // 定义一个函数用来创建和添加Marker
    function createAndAddMarker(latlng, options = {}) {
      const marker = L.marker(latlng, options);
      marker.addTo(map.value);
      return marker;
    }
    const markersData = [
      {
        locations: [
          [33.245220019410695, 114.19112205505373],
          [33.24651210282269, 114.18597221374513],
          [33.24220508383717, 114.18837547302248],
          [33.24609038325323, 114.19030666351318],

        ],
        iconName: "hs.png",
        // 其他相关属性...
      },

    ];

    function createDashedPolyline(feature, style) {
      const latLngs = feature.geometry.coordinates;
      if (feature.geometry.type === "Polygon") {
        // 取外圈线作为多段线处理
        latLngs = [latLngs[0]];
      } else if (feature.geometry.type === "MultiPolygon") {
        // 处理多个多边形，这里仅取第一个外圈线
        latLngs = [latLngs[0][0]];
      }

      const options = {
        ...style,
        dashArray: [5, 5], // 虚线长度与间距
        lineCap: "round", // 线头样式，可选
        lineJoin: "round", // 线交接处样式，可选
      };

      return L.polyline(latLngs, options);
    }

    // 添加行政区划边界的逻辑
    const loadBoundary = () => {
      L.geoJSON(boundaryData, {
        onEachFeature: function (feature, layer) {
          let style;

          switch (feature.properties.T) {
            case "未建成":
              style = {
                color: "#fff",
                fillColor: "#6ab04c",
                fillOpacity: 0.4,
                dashArray: [5, 5],
                weight: 1,
              };
              break;
            case "其他":
              style = {
                color: "#fff",
                fillColor: "#ffbe76",
                fillOpacity: 0.45,
                dashArray: [5, 5],
                weight: 1,
              };
              break;
            default:
              style = {
                color: "#D1E211",
                fillColor: "#226FC1",
                fillOpacity: 0,
                dashArray: [1, 1],
                weight: 1,
              };
          }

          if (
            feature.geometry.type === "Polygon" ||
            feature.geometry.type === "MultiPolygon"
          ) {
            // 设置填充样式
            layer.setStyle(style);

            // 处理每个外环线为虚线
            feature.geometry.coordinates.forEach((ring, index) => {
              if (index === 0 || feature.geometry.type === "Polygon") {
                // 对于多边形，只处理外环线
                const dashedLine = createDashedPolyline(
                  { geometry: { coordinates: [ring] } },
                  style
                );
                map.value.addLayer(dashedLine);
              }
            });
          } else if (
            feature.geometry.type === "LineString" ||
            feature.geometry.type === "MultiLineString"
          ) {
            const dashedLine = createDashedPolyline(feature, style);
            map.value.addLayer(dashedLine);
          }

          // 添加原始图层到地图上（用于显示填充区域）
          map.value.addLayer(layer);
        },
      }).addTo(map.value);
    };

    const removeMap = () => {
      if (mapObj.value) {
        mapObj.value.remove();
      }
    };

function clickNav(isShow){
  // console.log(isShow)
  state.circleShow = isShow.show
}
function circleHiddlen(e){
  // console.log('circle')
  state.circleShow = e.show
}
    
function chunkString(str, chunkSize) {
      if (str.length <= chunkSize) {
        return [str];
      }
      return [str.slice(0, chunkSize), ...chunkString(str.slice(chunkSize), chunkSize)];
    }
function tabDate(index){
  state.showDiv = false; // 点击后先隐藏div
  state.left1Cur = index
  setTimeout(() => {
    state.showDiv = true; // 200ms后再重新显示div（模拟刷新）
  }, 200);
}
function getData(){
  axios
    .get("https://zhfarm.laicunwang.com/api/environment/shangcaiqxdata", {sign:"c4c6cff9b7ec6b87fa953f77ec7e624b"})
    .then((res) => {
      console.log(res);
      // 空气检测数据
      let data1 = res.data.data.data1
      console.log(data1)
      // data1.forEach(item=>{
      //   item.date = timeStr(item.date,1)
      // })
      state.leftData1 = data1
      // 土壤检测数据
      let data2 = res.data.data.data2.lastDatas
      console.log(data2)

      // soil_temperature   温度
      // soil_moisture  湿度
      state.leftData2 = [
        {name:"温度",value:data2[0].soil_temperature,unit:"℃"},
        {name:"湿度",value:data2[0].soil_moisture,unit:"%"},
        {name:"ph值",value:data2[0].soil_ph,unit:""},
        {name:"氮",value:data2[0].nitrogen,unit:"mg/kg"},
        {name:"磷",value:data2[0].phosphorus,unit:"mg/kg"},
        {name:"钾",value:data2[0].potassium,unit:"mg/kg"}
      ]
      // 土壤温湿度
      state.leftData3.time =  res.data.data.data2.hoursResulttime.timeInfo
      state.leftData3.list[0] ={name:"温度",data:res.data.data.data2.HistorydataResult.soil_temperature}
      state.leftData3.list[1] = {name:"湿度",data:res.data.data.data2.HistorydataResult.soil_moisture}
      // console.log(state.leftData3)
      // 实时数据检测


      state.rightData1[0].value = res.data.data.data4.air_temperature
      state.rightData1[1].value = res.data.data.data4.air_humidity
      state.rightData1[2].value = data2[0].soil_temperature
      state.rightData1[3].value = data2[0].soil_moisture
      state.rightData1[4].value = res.data.data.data4.wind_cone
      state.rightData1[5].value = res.data.data.data4.light_intensity
      // leftData1:[
      //   {time:"11:00",wd:20,sd:26},


    });
}
onUnmounted(() => {
  // 清除定时器
  // if (intervalId) {
  //   clearInterval(intervalId);
  // }
  removeMap();
});
onBeforeUnmount(() => {
  // clearInterval(timer.value);
});
</script>
<style lang="less" scoped>
body {
  background-size: cover;
  line-height: 1.15;
}
.kong{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 20px;
  img{
    margin-bottom: 20px;
  }
}

.navBox{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 150px;
  background: linear-gradient( to bottom, rgba(3, 14, 25, 1) 0%,  rgba(3, 14, 25, 0.7) 60%,  rgba(3, 14, 25, 0));
}
.mainBox {
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
}
.flexColumn{
  display: flex;
  flex-direction: column;
}
.echarts{
  width: 100%;
  flex: 1;
}
.title{
  width:100%;
  height: 40px;
  font-weight: bold;
  background: url("../assets/img/huanjing/xbt.png") no-repeat left bottom;
  color: #fff;
  font-size: 20px;
  line-height: 20px;
  text-align: left;
  padding-left: 40px;
  position: relative;
  img{
    position: absolute;
    top: -3px;
    left: 16px;
    width: 21px;
    height: 28px;
  }
}
.title1{
  width:399px;
  height: 26px;
  background: url("../assets/img/datajc/cjx.png") no-repeat left bottom;
  color: #fff;
  font-size: 16px;
  line-height: 26px;
  text-align: left;
  padding-left: 20px;
  margin: 0 auto;
}
.left,.right{
  position: fixed;
  top: 100px;
  width: 432px;
  height: calc(100% - 120px);
  background: url("../assets/img/huanjing/ck.png") no-repeat;
  background-size: 100% 100%;
  z-index: 1000;
  padding: 20px 0;
}

.left{
  left: 10px;
  .leftBox1{
    height: 364px;
    align-items: center;
    .leftInfo1{
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      padding: 10px 0;
      .leftItem1{
        width: 379px;
        height: 50px;
        line-height: 50px;
        display: flex;
        font-size: 14px;
        background: url("../assets/img/datajc/left1item.png") no-repeat;
        margin: 5px 0;
        padding: 0 30px 0 20px;
        font-size: 16px;
        justify-content: space-between;
        .time{color: #13B0A1}
        .wd{color:#48A9CB }
        .sd{color: #9D781F}

      }


    }

  }
  .leftBox2{
    flex: 1;
  }
  .leftBox3{
    height: 255px;
    padding-bottom: 14px;
    display: flex;
    flex-wrap: wrap;
    .leftItem3{
      width: 33%;
      display: flex;
      align-items: center;
      padding: 0 10px;
      .iconBox{
        width: 58px;
        height: 57px;
        background: url("../assets/img/datajc/sj.png") no-repeat;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .itemRight{
        display: flex;
        flex-direction: column;
        span{
          display: block;
          text-align: left;
        }
        span:first-child{
          font-size: 16px;
          font-weight: bold;
          color: #00FFFF;
        }
        span:last-child{
          font-size: 14px;
          color:#fff;
          i{
          color: #00FFFF;
        }
        }
      }
    }
    //.leftItem3:nth-child(4),.leftItem3:nth-child(7){
    //  span:first-child{color: #ffc600}
    //}
  }
}
.right{
  right: 10px;
  .rightBox1{
    width: 100%;
    flex: 1;
    .rightInfo1{
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      padding: 30px 40px;
      .rightItem1{
        width: 140px;
        height: 101px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .valueBg{
          width: 140px;
          height: 30px;
          text-align: center;
          line-height: 30px;
          color: #fff;
          font-size: 18px;
          font-weight: bold;
        }
        .name{
          height:22px ;
          font-size: 12px;
          line-height: 20px;
          color: #fff;
        }
      }
      .rightItem1:nth-child(1),.rightItem1:nth-child(2){
        background: url("../assets/img/datajc/kq.png") no-repeat;
        .valueBg{
          background: linear-gradient(to bottom,#FFFFFF 0%,#FFFFFF 30%, #5CE6D4 60%);
          -webkit-background-clip: text;/*将设置的背景颜色限制在文字中*/
          -webkit-text-fill-color: transparent;/*给文字设置成透明*/
        }
      }
      .rightItem1:nth-child(3),.rightItem1:nth-child(4){
        background: url("../assets/img/datajc/tr.png") no-repeat;
        .valueBg{
          background: linear-gradient(to bottom,#FFFFFF 0%,#FFFFFF 30%, #B28639 60%);
          -webkit-background-clip: text;/*将设置的背景颜色限制在文字中*/
          -webkit-text-fill-color: transparent;/*给文字设置成透明*/
        }
      }
      .rightItem1:nth-child(5),.rightItem1:nth-child(6){
        background: url("../assets/img/datajc/fs.png") no-repeat;
        .valueBg{
          background: linear-gradient(to bottom,#FFFFFF 0%,#FFFFFF 30%, #64E1FF 60%);
          -webkit-background-clip: text;/*将设置的背景颜色限制在文字中*/
          -webkit-text-fill-color: transparent;/*给文字设置成透明*/
        }
      }
    }
  }
  .rightBox2{
    height: 487px;
    display: flex;
    flex-direction: column;
    .leftBox1Content{
      transform: scale(0.9);
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-top:-20px;
      .leftBox1ContentTop{
        width: 100%;
        height: 239px;
        background: url("../assets/img/gbzntyj/gaungai/x.png") no-repeat center center;
        position: relative;
        margin: 30px 0 40px;
        .circle{
          position: absolute;
          top: 50%;
          left: 50%;
          width: 239px;
          height: 239px;
          background: url("../assets/img/gbzntyj/gaungai/nq.png") no-repeat center center;
          margin: -120px 0 0 -120px;
          animation: guangying 2s linear infinite;
        }
        .circleImg{
          position: absolute;
          top: 50%;
          left: 50%;
          z-index: 999;
          width: 36px;
          height: 38px;
          margin: -19px 0 0 -18px;
          animation: left1Img 2s linear infinite;

        }
        .leftBox1ContentTopList{
          width: 100%;
          height: 100%;
          position: relative;
          .leftBox1ContentTopItem{
            width: 115px;
            height: 65px;
            background: url("../assets/img/gbzntyj/gaungai/llk.png") no-repeat;
            position: absolute;
            z-index: 9;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            span{
              display: block;
              font-size: 14px;
            }
            span.txt1{
              color: #fff;
              opacity: .9;
            }
            span.txt2{
              color: #00E9EF;
              font-weight: bold;
            }
          }
          .leftBox1ContentTopItem:nth-child(1){
            top: -8px;
            left: 0;
          }
          .leftBox1ContentTopItem:nth-child(2){
            top: -8px;
            right: 0;
          }
          .leftBox1ContentTopItem:nth-child(3){
            bottom: -8px;
            left: 0;
          }
          .leftBox1ContentTopItem:nth-child(4){
            bottom: -8px;
            right: 0;
          }
        }
      }
      .leftBox1ContentCenter{
        width: 100%;
        height: 46px;
        background: url("../assets/img/gbzntyj/gaungai/rq.png") no-repeat;
        line-height: 46px;
        padding: 0 60px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        .dateItem{
          font-size: 18px;
          color: #Fff;
          cursor: pointer;
        }
        .dateItem:hover,.dateItemCur{color: #ffc600;}
      }
      .leftBox1ContentBottom{
        width: 100%;
        flex: 1;
        .leftBox1ContentBottom1{
          display: flex;
          width: 100%;
          height: 100%;
        }
        .leftBox1ContentBottomItem{
          flex: 1;
          display: flex;
          font-size: 14px;
          margin: 20px 0;
          .leftItem{
            background: url("../assets/img/gbzntyj/gaungai/slk.png") no-repeat;
            width: 50px;
            height: 48px;
            display: flex;
            justify-content: center;
            align-items: center;
            img{
              width: 25px;
              height: 27px;
              animation: left1Img 1s linear infinite;
            }
          }
          .rightCon{
            display: flex;
            flex-direction: column;
            margin-left: 10px;
            span{
              display: block;
              text-align: left;
            }
            span.txt1{
              color: #00F6F8;
              font-weight: bold;
            }
            span.txt2{
              color: #fff;
            }
          }
        }
      }
    }
  }

}
//中间
//.center{
//  position: absolute;
//  top: 200px;
//  left: 500px;
//  background: url("../assets/img/datajc/zj.png") no-repeat;
//  width: 876px;
//  height: 377px;
//  z-index: 1000;
//}
.contentLine {
  background: #1AA19E;
  position: absolute;
}
.contentLine1{
  top: 1px;
  left: 0;
  width: 10%;
  height: 2px;
  /* 加上渐变效果，方可形成拖尾效果 */
  background: linear-gradient(90deg, transparent, #1AA19E);
  animation: animate1 4s linear infinite;
}
.contentLine2{
  top: -100%;
  right: 0;
  width: 2px;
  height: 20%;
  background: linear-gradient(180deg, transparent, #1AA19E);
  animation: animate2 4s linear infinite;
  /* 注意要加上延时触发动画效果，这样线条才会依次触发 */
  animation-delay: 1s;
}
.contentLine3{
  bottom: 1px;
  right: 0;
  width: 20%;
  background: linear-gradient(270deg, transparent, #1AA19E);
  animation: animate3 4s linear infinite;
  animation-delay: 2s;
}
.contentLine4{
  bottom: -100%;
  left: 1px;
  width: 2px;
  height: 10%;
  background: linear-gradient(360deg, transparent, #1AA19E);
  animation: animate4 4s linear infinite;
  animation-delay: 3s;
}
@keyframes animate1 {
  0% {
    left: -50%;
  }

  50%,
  100% {
    left: 100%;
  }
}

@keyframes animate2 {
  0% {
    top: -100%;
  }

  50%,
  100% {
    top: 100%;
  }
}
@keyframes animate3 {
  0% {
    right: -100%;
    height: 3px;
  }

  50%,
  100% {
    height: 2px;
    right: 100%;
  }
}
@keyframes animate4 {
  0% {
    bottom: -100%;
  }

  50%,
  100% {
    bottom: 100%;
  }
}
@keyframes left1Img {
  /*引用动画名称*/
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.8);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}
</style>
